<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.EnterReleaseNumber')"
      :width="$selectByLang('300px', '380px')"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="true"
      @close="cancel"
    >
      <div>
        <el-form :label-width="$selectByLang('60px', '140px')" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_BlReleasingNoP')" :style="$selectByLang('', 'width: 400px')">
            <el-input v-model="surrenderedNo" no="surrenderedNo" />
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align:right">
          <el-button no="confirm" type="primary" @click="saveHandler">{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="cancel" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'

export default {
  name: 'SurrenderedNoWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      loading: false,
      gridApi: null,
      options: {
        columnApi: null
      },
      surrenderedNo: ''
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  methods: {
    cancel() {
      this.surrenderedNo = ''
      this.$emit('visibleHandler')
    },
    saveHandler() {
      if (!this.surrenderedNo || this.surrenderedNo.length === 0 || this.surrenderedNo.trim() === '') {
        this.$confirm(this.$t('Clearing.AreToUseAnNumber'), '', {
          confirmButtonText: this.$t('common.btn.yes'),
          cancelButtonText: this.$t('common.btn.no'),
          type: 'warning'
        }).then(async() => {
          this.$emit('commit', { surrenderedNo: this.surrenderedNo })
          this.cancel()
        })
      } else {
        this.$emit('commit', { surrenderedNo: this.surrenderedNo })
        this.cancel()
      }
    }
  }
}
</script>
<style scoped>

</style>

